import { render } from "./model.vue?vue&type=template&id=5a653782&ts=true"
import script from "./model.vue?vue&type=script&lang=ts"
export * from "./model.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__